import React from "react";

import {Controller} from "react-hook-form";
import ReactHookFormDropdownLetterboxToUsers from "root/ReactHookForm/ui/ReactHookFormDropdownLetterboxToUsers";
import PropTypes from "prop-types";

const DropdownLetterboxToUsers = ({ validate, control, name, readOnly, options}) =>
{
    return (
        <Controller
            control={control}
            name={name}
            rules={{ required: true, validate: validate}}
            render={({field: { onChange, value, name, ref }, fieldState: { invalid, isTouched, isDirty, error }, formState,}) => (
                <ReactHookFormDropdownLetterboxToUsers name={name} onChange={onChange} value={value} inputRef={ref} options={options} readOnly={readOnly}/>
            )}/>
    )
}

export default DropdownLetterboxToUsers ;

DropdownLetterboxToUsers.propTypes = {
    name: PropTypes.string.isRequired
};